import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
  categoryName?: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  category,
  categoryName,
  rating,
  views,
  chapters,
  status,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={`${title} - 韩国漫画`}
          title={`${title} - 韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          width="800"
          height="1100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-label ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="text-xs text-background-50/90 font-label bg-black/40 px-2 py-1 rounded">
            共 {chapters} 话
          </span>
        </div>
      </div>
      <h3 className="text-sm font-label font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5 truncate">{author}</p>
      <div className="flex items-center gap-3 mt-1.5">
        <span className="flex items-center gap-0.5 text-xs text-accent-500">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </span>
        <span className="flex items-center gap-0.5 text-xs text-foreground-400">
          <i className="ri-eye-line text-[10px]"></i>
          {formatViews(views)}
        </span>
      </div>
    </Link>
  );
}